<template>
  <component :is="component" />
</template>

<script>
import salePlanChangeCompanyCheck from '../components/salePlanChangeCompanyCheck.vue'
import salePlanChangeCompanyEdit from '../salePlanChangeCompany.vue'
export default {
  components: {
    salePlanChangeCompanyCheck,
    salePlanChangeCompanyEdit
  },
  data() {
    return {
      component: 'salePlanChangeCompanyCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'salePlanChangeCompanyCheck' : 'salePlanChangeCompanyEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/check/salePlanChangeCompanyCheck.vue